import React from 'react';
import './index.scss';
export const MaterialRadio = ({ label = '', ...props }) => (
  <label className='pure-material-radio'>
    <input type='radio' {...props} />
    <span>{label}</span>
  </label>
);
